import axios from "axios";

const URL_AUTH = import.meta.env.VITE_AUTH_URL;

export const GetPlanDetailsService = (token, planId) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axios.get(
        `${URL_AUTH}/api/general/v1/info/plan/${planId}`,
        {
          headers: {
            "X-localization": `${window.localStorage.getItem("i18nextLng")}`,
            Authorization: `Bearer ${token}`,
          }
        }
      );
      console.log(response);
      resolve(response.data.data);
    } catch (error) {
      reject(error);
    }
  });
};